var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("hr"),
    _vm._v(" "),
    _c("p", [
      _c("strong", [_vm._v("Enfant " + _vm._s(parseInt(_vm.index) + 1))])
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "form-group",
        class: { error: _vm.$v.child.first_name.$error }
      },
      [
        _c("label", { attrs: { for: "child_first_name" + _vm.index } }, [
          _vm._v("Prénom de l’enfant disparu")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "input-group" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model.trim",
                value: _vm.$v.child.first_name.$model,
                expression: "$v.child.first_name.$model",
                modifiers: { trim: true }
              }
            ],
            attrs: {
              type: "text",
              name: "child_first_name",
              id: "child_first_name" + _vm.index,
              required: ""
            },
            domProps: { value: _vm.$v.child.first_name.$model },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(
                  _vm.$v.child.first_name,
                  "$model",
                  $event.target.value.trim()
                )
              },
              blur: function($event) {
                return _vm.$forceUpdate()
              }
            }
          }),
          _vm._v(" "),
          _vm.$v.child.first_name.$error && !_vm.$v.child.first_name.required
            ? _c("p", { staticClass: "form-error" }, [
                _vm._v("\n          Ce champ est obligatoire\n        ")
              ])
            : _vm._e()
        ])
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "form-group",
        class: { error: _vm.$v.child.last_name.$error }
      },
      [
        _c("label", { attrs: { for: "child_last_name" + _vm.index } }, [
          _vm._v("Nom de l’enfant disparu")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "input-group" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model.trim",
                value: _vm.$v.child.last_name.$model,
                expression: "$v.child.last_name.$model",
                modifiers: { trim: true }
              }
            ],
            attrs: {
              type: "text",
              name: "child_last_name",
              id: "child_last_name" + _vm.index,
              required: ""
            },
            domProps: { value: _vm.$v.child.last_name.$model },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(
                  _vm.$v.child.last_name,
                  "$model",
                  $event.target.value.trim()
                )
              },
              blur: function($event) {
                return _vm.$forceUpdate()
              }
            }
          }),
          _vm._v(" "),
          _vm.$v.child.last_name.$error && !_vm.$v.child.last_name.required
            ? _c("p", { staticClass: "form-error" }, [
                _vm._v("\n          Ce champ est obligatoire\n        ")
              ])
            : _vm._e()
        ])
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "form-group", class: { error: _vm.$v.child.age.$error } },
      [
        _c("label", { attrs: { for: "child_age" + _vm.index } }, [
          _vm._v("Âge de l’enfant disparu")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "input-group" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model.trim",
                value: _vm.$v.child.age.$model,
                expression: "$v.child.age.$model",
                modifiers: { trim: true }
              }
            ],
            attrs: {
              type: "text",
              name: "child_age",
              id: "child_age" + _vm.index,
              required: ""
            },
            domProps: { value: _vm.$v.child.age.$model },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.$v.child.age, "$model", $event.target.value.trim())
              },
              blur: function($event) {
                return _vm.$forceUpdate()
              }
            }
          }),
          _vm._v(" "),
          _vm.$v.child.age.$error && !_vm.$v.child.age.required
            ? _c("p", { staticClass: "form-error" }, [
                _vm._v("\n          Ce champ est obligatoire\n        ")
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.$v.child.age.$error && !_vm.$v.child.age.numeric
            ? _c("p", { staticClass: "form-error" }, [
                _vm._v("\n          Veuillez entrer un nombre\n        ")
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.$v.child.age.$dirty &&
          _vm.$v.child.age.required &&
          _vm.$v.child.age.$error &&
          !_vm.$v.child.age.between
            ? _c("p", { staticClass: "form-error" }, [
                _vm._v(
                  "\n          L’enfant doit être âgé de " +
                    _vm._s(_vm.$v.child.age.$params.between.min) +
                    " à " +
                    _vm._s(_vm.$v.child.age.$params.between.max) +
                    " ans\n        "
                )
              ])
            : _vm._e()
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-aec10106", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aec10106","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./js/MissingChildIntakeFormChild_fr.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-aec10106","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./js/MissingChildIntakeFormChild_fr.vue
// module chunks = 0